module.exports = __webpack_public_path__ + "static/img/xiahui.1c70e88a.jpg";